export const GET_SALARY_SETTINGS = "GET_SALARY_SETTINGS";

export const CREATE_SALARY_SETTING = "CREATE_SALARY_SETTING";
export const UPDATE_SALARY_SETTING = "UPDATE_SALARY_SETTING";
export const DELETE_SALARY_SETTING = "DELETE_SALARY_SETTING";

export const OPEN_SALARY_DIALOG = "OPEN_SALARY_DIALOG";
export const CLOSE_SALARY_DIALOG = "CLOSE_SALARY_DIALOG";
